import { Server } from '../../units/server/server';
import { Notification } from '../../notification/notfication';
import { Confirm } from '../../confirm/confirm';
import { ServerlistItem } from './serverlistItem';
import { ServerAction } from '../interface';
import { ServerlistItemUI } from './serverlistItemUI';
import ServerUnit = Server.ServerUnit;
import ServerEvent = Server.ServerEventType;
import ServerStatus = Server.ServerStatus;
import ServerOptions = Server.ServerOptions;
import ServerVisibilityOption = Server.ServerVisibilityOption;
import VoiceServerQueryResponse = Server.VoiceServerQueryResponse;
import Utilities = Server.Utilities;
import GameServerQueryResponse = Server.GameServerQueryResponse;

export class Serverlist {
    public static readonly BASE_SELECTOR = '.gamecloud-layout';
    private items: ServerlistItem[] = [];

    constructor() {
      $('.gameserver--table__row').each((index : number, element : HTMLElement) => {
        const ui = new ServerlistItemUI(element);
        this.items.push(new ServerlistItem(ui));
      });
      Server.Utilities.registerLazyServerQuery();
    }
}

export function initServerList() {
    if($(Serverlist.BASE_SELECTOR).length) {
        Utilities.registerLazyServerQuery();
        new Serverlist();
    }
}
